<template>
    <v-card outlined class='mb-4'>
        <v-card-title>ارتباط با مالک</v-card-title>
        <v-divider/>
        <v-card-text>
            <User :user='user' noMenu class='mb-3'/>
            <v-form v-model='valid' @submit.prevent='sendMessageToOwner'>
                <v-textarea
                    v-model='text'
                    auto-grow
                    class='mb-2'
                    rows='2'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                    hide-details
                >
                    <template #label>
                        متن پیام
                    </template>
                </v-textarea>
                <v-btn
                    color='primary'
                    class='white--text'
                    block
                    type='submit'
                    :loading='loadingSendMessage'
                    :disabled='loadingSendMessage || text.length < 3'
                >
                    ارسال پیام
                </v-btn>

            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";
import {mapActions} from 'vuex';
import User from "@/components/User";

export default {
    name: "sendMessageToOwner",
    components: {User},
    props: {
        user: Object
    },
    data() {
        return {
            rules: {
                text: [
                    v => !!v || 'متن پیام اجباری میباشد'
                ]
            },
            valid: false,
            text: '',
            loadingSendMessage: false,
        }
    },
    methods: {
        async sendMessageToOwner() {
            this.loadingSendMessage = true;
            await axios
                .post('/api/messages/', {
                    text: this.text, to: this.user._id
                })
                .then(response => {
                    this.loadingSendMessage = false;
                    this.text = '';
                    this.$snackbar.showMessage(
                        {
                            content: 'پیام به مالک ارسال شد',
                            color: 'success'
                        }
                    );
                })
                .catch(err => {
                    this.loadingSendMessage = false;
                    this.$snackbar.showMessage(
                        {
                            content: 'ارسال نشد',
                            color: 'red'
                        }
                    );
                    console.error(err);
                });
        },
        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        ...mapActions(['showNavigation'])
    },
    computed: {
    }
}
</script>

<style scoped>

</style>